import { apiClient } from './api'
import { track } from '../utils/analytics'

/**
 * Sprint 30 — email verification.
 *
 * `verifyEmail` is public (the link may land in a logged-out browser);
 * a 400 means the token is invalid/expired/used. `resendVerification`
 * requires auth and always resolves on 202 — already-verified accounts
 * get the same response (no email), so the UI must not branch on it.
 */
export const emailVerificationService = {
  verifyEmail: async (token: string): Promise<void> => {
    await apiClient.post('/api/v1/auth/verify-email', { token })
    track('email_verified')
  },

  resendVerification: async (): Promise<void> => {
    await apiClient.post('/api/v1/auth/resend-verification')
  },
}
